import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';

import { legShape } from 'constants/propTypes';

import useCheckinTimesQuery from 'components/queries/useCheckinTimesQuery';

import serviceTypeCodes from 'constants/serviceTypeCodes';
import { LONDON_UIC, PARIS_UIC, BRUSSEL_UIC, AMSTERDAM_UIC } from 'constants/directEurostarStations';

import {
  RecommendedStationArrivalTimeLoader,
  StyledRecommendedStationArrivalTimeMessage
} from './RecommendedStationArrivalTimeMessage.style';

import { isMoreThanXMinutesAgo } from 'utils/dates';

const RecommendedStationArrivalTimeMessage = ({
  bookingReference,
  journey,
  journey: {
    serviceType: { code },
    origin: { uic }
  }
}) => {
  const { recommendedStationArrivalTime, loading, error } = useCheckinTimesQuery({ reference: bookingReference, journey });

  const isDeparted = !isMoreThanXMinutesAgo(0)(journey?.timing?.isoDate);

  const isExpectedServiceCode = [serviceTypeCodes.EUROSTAR].includes(code);
  const isExpectedStationUic = [LONDON_UIC, PARIS_UIC, BRUSSEL_UIC, AMSTERDAM_UIC].includes(uic);

  const displayStationArrivalRecommendation =
    isExpectedServiceCode && isExpectedStationUic && !isDeparted && !!recommendedStationArrivalTime;

  const message = 'journeySegment.recommendedStationArrival';

  if (error) {
    return null;
  }

  if (loading) {
    return <RecommendedStationArrivalTimeLoader data-testid="recommended-station-arrival-time-loader" />;
  }

  return (
    displayStationArrivalRecommendation && (
      <StyledRecommendedStationArrivalTimeMessage>
        <FormattedMessage id={message} values={{ recommendedStationArrivalTime }} />
      </StyledRecommendedStationArrivalTimeMessage>
    )
  );
};

RecommendedStationArrivalTimeMessage.propTypes = {
  journey: legShape,
  bookingReference: PropTypes.string.isRequired
};

export default injectIntl(RecommendedStationArrivalTimeMessage);
